import EnvFile from "./assets/env-stg.json";

// Set public path for asset loading (must run before main bundle)
// eslint-disable-next-line no-undef
__webpack_public_path__ = "https://ze2-static-stg.mlb.com/";

window.MLBBest = {
  envVariables: EnvFile,
};
